export default {"src":"/_next/static/media/sign-up-close-icon.086b83fc.svg","height":24,"width":16,"blurWidth":0,"blurHeight":0};